import React from 'react'
import { CoreButton } from 'src/components/core'
import { useTheme, alpha } from '@material-ui/core/styles' // Import alpha helper for opacity
import { getColorVariant } from 'src/components/core/functions' // Import getColorVariant function
import { withStyles } from '@material-ui/core'
import styles from './styles'
const CoreNavigation = props => {
  const {
    classes,
    tabList,
    color,
    backgroundColor,
    size,
    loading,
    alignment = 'horizontal',
    iconPosition = 'start',
    fullWidth = false,
  } = props
  const theme = useTheme()

  return (
    <div
      className={classes.root}
      style={{
        flexDirection: alignment === 'horizontal' ? 'row' : 'column',
        alignItems: alignment === 'horizontal' ? 'center' : 'flex-start',
      }}
    >
      {tabList.map((tab, index) => (
        <CoreButton
          key={index}
          onClick={tab.onClick}
          color={color}
          variant="text"
          size={size}
          disabled={loading}
          alignment={alignment}
          style={{
            width: fullWidth ? '100%' : 'auto',
            fontWeight: tab.isActive ? 600 : 500,
            backgroundColor: tab.isActive
              ? backgroundColor === 'primary'
                ? '#E3F3FF'
                : alpha(getColorVariant(theme, backgroundColor).main, 0.1)
              : 'transparent', // Example of hover style when active
          }}
          startIcon={iconPosition === 'start' ? tab.icon : null}
          endIcon={iconPosition === 'end' ? tab.icon : null}
        >
          {tab.label}
        </CoreButton>
      ))}
    </div>
  )
}

export default withStyles(styles)(CoreNavigation)
